import { mainConfig } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import convertDate from "../../../utils/convertDate";
import { getPrintFieldNames } from "../../../utils/getPrintFieldNames";
import { itemTypeOptions } from "../../MainStructure/SearchBar/data/searchItemUtils";
import NOPIC from "../../../assets/nopic.svg";
import { toPrice } from "../../../utils/toPrice";
import { exportToExcel } from "../../../utils/exportToExcel";

export const printTable = ({
  t,
  title,
  headers,
  data = [],
  country,
  warehouses = [],
  xls = false,
}: {
  t: any;
  title: string;
  headers: stdObject[];
  data?: stdObject[];
  country: string;
  warehouses?: stdObject[];
  xls?: boolean;
}) => {
  const writeInfo = (type: string, code: string, intData: stdObject) => {
    switch (type) {
      case "type":
        return t(
          itemTypeOptions.find(
            (e: stdObject) => Number(e.value) === intData[code],
          )?.label,
        );
      case "date":
        return convertDate({ info: intData[code], time: true, t });
      case "image":
        return xls
          ? intData[code]
          : `<img class="image" src="${mainConfig.url}/images/ART/small/${intData.IMGUART ?? intData.CODART}.${intData[code]}" onerror="this.src='${NOPIC}'" loading="lazy" alt="${intData[code]}" />`;
      case "check":
        return xls
          ? intData[code]
          : `<input type="checkbox" ${intData[code] === 1 ? "checked=checked" : ""} />`;
      case "cost":
        return toPrice(intData[code][country]);
      case "tax":
        return intData[code][country] + "%";
      case "price":
        return toPrice(intData.PREART?.[country]?.[code]?.PRELTA);
      case "stock":
        const stock = intData.ALMART[code];
        if (intData.ALMART[code]) {
          return stock.ACTSTO === stock.DISSTO
            ? stock.ACTSTO
            : `${stock.DISSTO} / ${stock.ACTSTO}`;
        } else {
          return 0;
        }
      default:
        return intData[code] ?? "";
    }
  };
  if (xls) {
    const preList: any[] = [];
    let preCell: string[] = [];
    headers.forEach((item) => {
      preCell.push(getPrintFieldNames(t, item.code));
    });
    preList.push(preCell);

    data.forEach((item) => {
      preCell = [];
      headers.forEach((hd) => {
        preCell.push(writeInfo(hd.type, hd.code, item));
      });
      preList.push(preCell);
    });
    exportToExcel(title, preList);
  } else {
    const tableHTML = `
      <html>
        <head>
          <title>Imprimir Tabla</title>

          <style>
            body {
              font-family: Arial;
              padding: 20px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              border: 1px solid #000;
              padding: 8px;
            }

            th {
              background: #f0f0f0;
            }

            .image {
              border: solid 1px black;
              width: 75px;
              height: 50px;
            }

            .innerTable {
              border: none; 
              padding: 0px;
            }
          </style>
        </head>

        <body>
          <table>
            <thead>
              <tr>
              ${headers
                .map(
                  (item) => `
                      <th>${item.label ?? getPrintFieldNames(t, item.code)}</th>
                  `,
                )
                .join("")}
              </tr>
            </thead>
            <tbody>
              ${data
                .map(
                  (item) => `
                    <tr>
                    ${headers.map((hd) => `<td align="${["cost", "price"].includes(hd.type) ? "right" : ["image", "type", "brand", "check", "cat", "tax", "stock"].includes(hd.type) ? "center" : "left"}">${writeInfo(hd.type, hd.code, item)}</td>`).join("")}
                    </tr>
                  `,
                )
                .join("")}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");

    if (printWindow) {
      printWindow.document.write(tableHTML);
      printWindow.document.close();

      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  }
};
